import React, { useEffect, useState } from 'react'
// * Helpers
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";
import { VIEW } from '../../assets/Constants/actionsTypes';
// Reac number format
import NumberFormat from 'react-number-format';


/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight } from 'react-icons/im'
import validator from 'validator';

const Step1 = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');
    // Input values state
    const [code, setCode] = useState('');
    const [igdp, setIGDP] = useState('');
    const [name, setName] = useState('');
    const [igex, setIGEX] = useState('');
    const [baseYear, setBaseYear] = useState('');
    const [selectedNominal, setSelectedNominal] = useState('n');
    const [historicalYear, setHistoricalYear] = useState('')
    const [description, setDescription] = useState('')

    // we use useEffect to call the function that returns the step1 data
    useEffect(() => {
        if (props.activeStep === 1) {
            getStep1Data();
        }
    }, [props.activeStep]); // eslint-disable-line react-hooks/exhaustive-deps

    const getStep1Data = async () => {
        try {
            // gets data from API
            const response = await API.get(`/model/step1GetData?modelId=${props.modelData.modelid}`);
            // if error in request
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                // settings up the state of each input
                setCode(response.data.data.code);
                setIGDP(response.data.data.igdp);
                setName(response.data.data.name);
                setIGEX(response.data.data.igex);
                setBaseYear(response.data.data.baseYear);
                setHistoricalYear(response.data.data.historicalYears);
                setSelectedNominal(response.data.data.nominal);
                setDescription(response.data.data.description === null ? '' : response.data.data.description);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // * This function is called when the NEXT arrow is clicked.
    // * Saves the data of the step 1
    // * If the saves was ok, the step 2 is called
    const onNextClick = async () => {
        // Only saves when is in edit mode
        if (props.isEditMode) {
            // * When calling an async/await function that returns a boolean, you must wait for its response, 
            // * since it is a promise and will NOT return the desired bool.
            const returnValue = await saveStep1Data();
            if (returnValue) {
                props.changeStep(2);
            }
        } else {
            // Pass to step 2 without save
            props.changeStep(2);
        }
    }

    // Calls the API to save the data
    const saveStep1Data = async () => {
        // empty validations
        if (validator.isEmpty(code.toString()) || validator.isEmpty(name.toString()) ||
            validator.isEmpty(igdp.toString()) || validator.isEmpty(igex.toString()) ||
            validator.isEmpty(baseYear.toString()) || validator.isEmpty(historicalYear.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        // number validations
        if (!validator.isFloat(igdp)) {
            Notifications.notify(t('model.igdp_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(igex)) {
            Notifications.notify(t('model.igex_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(baseYear.toString())) {
            Notifications.notify(t('model.baseYear_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(historicalYear.toString())) {
            Notifications.notify(t('model.historicalYear_number'), ERROR_NOTIFICATION);
            return false;
        }
        if(parseFloat(historicalYear.toString()) < 1){
            Notifications.notify(t('model.historicalYear_min'), ERROR_NOTIFICATION);
            return false;
        }

        // data to be sent
        let data = {
            modelid: props.modelData.modelid,
            code: code,
            name: name,
            description: description === '' ? null : description,
            nominal: selectedNominal,
            baseYear: baseYear,
            historicalYears: historicalYear,
            igdp: igdp,
            igex: igex
        }

        // * call the api to do the upsert
        const res = await API.post('/model/step1InsertData', data);

        // * if errors exist, it is displayed as a notification
        if (res.data.code !== 100) {
            Notifications.notify(t(`model.${res.data.code}`), ERROR_NOTIFICATION);
            return false;
        }

        return true;
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step1_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-8">
                    {/**Form step1*/}
                    <div className="form-row">
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.code')}</label>
                            <input
                                type="text"
                                className="form-control ilo-input ilo-modal-input inputs_width_special"
                                disabled={!props.isEditMode}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.name')}</label>
                            <input
                                type="text"
                                className="form-control ilo-input ilo-modal-input inputs_width_special"
                                disabled={!props.isEditMode}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.igdp')}</label>
                            <NumberFormat
                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                thousandsGroupStyle="thousand"
                                value={igdp}
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                                disabled={!props.isEditMode}
                                onValueChange={(values) => {
                                    setIGDP(values.value);
                                }}
                            />
                        </div>
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.igex')}</label>
                            <NumberFormat
                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                thousandsGroupStyle="thousand"
                                value={igex}
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                                disabled={!props.isEditMode}
                                onValueChange={(values) => {
                                    setIGEX(values.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.baseYear')}</label>
                            <input
                                type="text"
                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                disabled={!props.isEditMode}
                                value={baseYear}
                                onChange={(e) => setBaseYear(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.projection_titile')}</label>
                            <div className="form-check-inline projection_margin">
                                <label className="form-check-label ilo_lbl_general">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        onChange={(e) => { setSelectedNominal(e.target.value) }}
                                        value='n'
                                        checked={selectedNominal === 'n'}
                                        disabled={!props.isEditMode}
                                    />
                                    {t('model.nominal')}
                                </label>
                            </div>
                            <div className="form-check-inline projection_margin">
                                <label className="form-check-label ilo_lbl_general">
                                    <input type="radio" className="form-check-input"
                                        onChange={(e) => { setSelectedNominal(e.target.value) }}
                                        value='r'
                                        checked={selectedNominal === 'r'}
                                        disabled={!props.isEditMode}
                                    />
                                    {t('model.real')}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-5">
                            <label className="required ilo_lbl_general">{t('model.historicalYears')}</label>
                            <input
                                type="text"
                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                value={historicalYear}
                                onChange={(e) => setHistoricalYear(e.target.value)}
                                disabled={!props.isEditMode}
                            />
                        </div>
                        <div className="form-group col-md-5">
                            <span className='model_warning_quote'><span style={{color: "red"}}>*</span>&nbsp;{t('model.warning_quote01')}</span>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-9">
                            <label className="ilo_lbl_general">{t('model.description')}</label>
                            <textarea
                                className="form-control ilo-input ilo-modal-input-text-area"
                                rows="4"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={!props.isEditMode}
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4"></div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    {props.isActionView === VIEW ? null : !props.isEditMode ? (
                        <button
                            onClick={() => { props.editSteps(); }}
                            className="btn btn-primary ilo-btn"
                            style={{ marginBottom: "10px", marginRight: "3px" }}
                        >
                            {t('model.step7_edit_btn')}
                        </button>
                    ) : null
                    }
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step1